import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParameterSearch } from './components/parameter-search/parameter-search.component';
import {ProjectParametersService} from "@catmodels/project-parameters/services/project-parameters.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIBaseModule} from "@catui/ui-base.module";
import {UIFormModule} from "@catuiform/ui-form.module";
import {ParametersModule} from "@catmodels/parameters/parameters.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIBaseModule,
    UIFormModule,
    ReactiveFormsModule,
    ParametersModule,
  ],
  providers: [ProjectParametersService],
  declarations: [ParameterSearch]
})
export class ProjectParametersModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-parameters/project-parameters.module.ts